module.exports = __webpack_public_path__ + "img/sass.3f14c92e.png";